import { render, staticRenderFns } from "./imgUpload.vue?vue&type=template&id=04c71dd0&scoped=true&"
import script from "./imgUpload.vue?vue&type=script&lang=js&"
export * from "./imgUpload.vue?vue&type=script&lang=js&"
import style0 from "./imgUpload.vue?vue&type=style&index=0&id=04c71dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c71dd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c71dd0')) {
      api.createRecord('04c71dd0', component.options)
    } else {
      api.reload('04c71dd0', component.options)
    }
    module.hot.accept("./imgUpload.vue?vue&type=template&id=04c71dd0&scoped=true&", function () {
      api.rerender('04c71dd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pallet/components/imgUpload.vue"
export default component.exports